import { useMemo } from "react";

import { isNil } from "lodash";

import { useRoleContext } from "./useRoleContext";
import { useSubscriptionStatus } from "./useSubscriptionStatus";
import { useSwrFetch } from "./useSwrFetch";

interface CarrierCompanyLimitsResponse {
  remaining_bookings: number;
}

export function useCarrierCompanyBookingLimits() {
  const { role } = useRoleContext();
  const { subscription } = useSubscriptionStatus();

  // CARRIER_ESSENTIALS_V2 is intentionally excluded: V2 carriers have no
  // remaining-bookings concept since they are locked out of non-partner
  // shipments entirely and partner bookings are unlimited.
  const url = useMemo(() => {
    if (
      role?.company?.id &&
      subscription &&
      (subscription.subscription_plan === "CARRIER_ESSENTIALS" ||
        subscription.subscription_plan === "CARRIER_BRONZE" ||
        subscription.subscription_plan === "CARRIER_SILVER" ||
        subscription.subscription_plan === "CARRIER_GOLD" ||
        subscription.subscription_plan === "CARRIER_PLATINUM")
    ) {
      return `/subscription/company/${role.company.id}/bookings-left`;
    }
    return null;
  }, [role?.company?.id, subscription]);

  const {
    data,
    loading,
    error,
    refetch: refetchLimits,
  } = useSwrFetch<CarrierCompanyLimitsResponse>({
    url,
    errorMessage: "Failed to fetch booking limits",
  });

  const limits =
    !isNil(data) && !isNil(data.remaining_bookings)
      ? { remainingBookings: data.remaining_bookings }
      : null;

  return {
    limits,
    loading,
    error,
    refetchLimits,
  };
}
